<template>
  <div>
    <canvas ref="bubbleChartCanvas"></canvas>
  </div>
</template>

<script>
export default {
  name: 'BubbleChart',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      const ctx = this.$refs.bubbleChartCanvas.getContext('2d');
      new Chart(ctx, {
        type: 'bubble',
        data: this.chartData,
        options: this.chartOptions,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BubbleChart.vue